import { portalPaths } from '@provision/portal-routes';
import { Navigate } from 'react-router-dom';
import { isNullish } from 'remeda';
import { useGlobalStore } from 'src/store';
import { useNavigateRoute } from 'src/utils/routing';
import { useScreenDimensions } from 'src/utils/system';

const REDIRECT_MAP: Record<string, string> = {
  [portalPaths.crm.organizations()]: portalPaths.entity.all({
    entityName: 'sites',
  }),
  [portalPaths.crm.projects()]: portalPaths.entity.all({
    entityName: 'projects',
  }),
  [portalPaths.crm.users()]: portalPaths.entity.all({
    entityName: 'clients',
  }),
};

export const CRM = () => {
  const { isMobile } = useScreenDimensions();
  const selectedPartnerId = useGlobalStore.use.selectedPartnerId();
  const { pathnameWithoutPrefix } = useNavigateRoute();

  if (isMobile || isNullish(selectedPartnerId)) {
    return <Navigate to={portalPaths.root()} replace />;
  }

  return (
    <Navigate to={REDIRECT_MAP[pathnameWithoutPrefix] || portalPaths.root()} replace />
  );
};
